/**
 * Klausuren (Roadmap F-22, Stufe 3) - reine Hilfen.
 *
 * Eine Klausur ist ein Kalendertermin mit `klausur`; ihr Lernplan besteht
 * aus normalen Aufgaben mit `examId`, eingeplant fuer einen Tag.
 */
import { addDays, differenceInDays } from '@/lib/datetime';
import type { CalendarEvent, LocalDate } from '@/domain/types';

/** Datum einer Klausur. */
export function klausurDatum(e: CalendarEvent): LocalDate {
  return String(e.start).slice(0, 10);
}

/** Lerntage: ab heute (bzw. ab `ab`) bis zum Vortag der Klausur. */
export function lerntage(heute: LocalDate, datum: LocalDate): LocalDate[] {
  const tage: LocalDate[] = [];
  for (let d = heute; d < datum; d = addDays(d, 1)) tage.push(d);
  return tage;
}

/** "heute", "morgen", "in 12 Tagen", "vorbei". */
export function countdown(heute: LocalDate, datum: LocalDate): string {
  const tage = differenceInDays(heute, datum);
  if (tage < 0) return 'vorbei';
  if (tage === 0) return 'heute';
  if (tage === 1) return 'morgen';
  return `in ${tage} Tagen`;
}
